import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import { format } from 'date-fns'
import type { IntlService } from 'ember-intl'
import type SchoolSubscription from 'teacher-ui-client/models/school-subscription'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'

interface Signature {
  Element: HTMLTableElement
  Args: {
    schoolSubscriptions: SchoolSubscription[]
  }
}

export class RolloverSubscriptionsTable extends Component<Signature> {
  @service intl!: IntlService

  get rows() {
    const dateFormat = this.intl.t('dateFormats.dateFns.d MMM yyyy')
    return this.args.schoolSubscriptions.map((schoolSub) => {
      const startDate = schoolSub.startDate ? format(schoolSub.startDate, dateFormat) : ''
      const endDate = schoolSub.endDate ? format(schoolSub.endDate, dateFormat) : ''

      const isUnlimited = schoolSub.softCapacity === 'unlimited'
      const softCapacity = isUnlimited
        ? this.intl.t(`manage.rollover.subscriptionsTable.cells.unlimited`)
        : schoolSub.softCapacity

      return { startDate, endDate, softCapacity }
    })
  }

  <template>
    <table data-test-rollover-subscriptions-table ...attributes>
      <thead>
        <tr>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/3">
            {{t "manage.rollover.subscriptionsTable.fields.startDate"}}
          </th>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/3">
            {{t "manage.rollover.subscriptionsTable.fields.endDate"}}
          </th>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/3">
            <span class="flex justify-between gap-2">
              {{t "manage.rollover.subscriptionsTable.fields.capacity"}}
              <span>
                <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-300 h-5 w-5 cursor-pointer" />
                <Tooltip @text={{t "manage.rollover.subscriptionsTable.note"}} />
              </span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {{#each this.rows as |row index|}}
          <tr data-test-tr={{index}}>
            <td class="table-box table-box-cell bg-juicy-orange-50" data-test-td="start-date">{{row.startDate}}</td>
            <td class="table-box table-box-cell bg-juicy-orange-50" data-test-td="end-date">{{row.endDate}}</td>
            <td
              class="table-box table-box-cell bg-juicy-orange-50"
              data-test-td="soft-capacity"
            >{{row.softCapacity}}</td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </template>
}

export default RolloverSubscriptionsTable
